import React from "react";
import { CiWarning } from "react-icons/ci";
import { MdContentCopy } from "react-icons/md";

const Withdraw = ({ show, setShow }) => {
  return (
    <>
      {show ? (
        <div className="profile-modal-overlay">
          <div className="profile-modal-container">
            <div className="close-profile">
              <button className="profile-close-button">
                <button
                  className="profile-close-button"
                  onClick={() => setShow(false)}
                >
                  <img src="/icons/cancel.svg" alt="" />
                </button>
              </button>
            </div>
            <h2 className="profile-modal-title">Withdraw from Wallet </h2>

            <div className="profile-form-section">
              <div className="warning-tab">
                <p className="warns">
                  {" "}
                  <CiWarning className="warning-icon" /> Never share your
                  private key or seed phrase with anyone
                </p>
              </div>
              <div className="warning-widthraw">
                <p className="add-key">
                  {" "}
                  2oBKcKs7Q19BBjeUGKd6S2SFvrpTsd2kDgnoYXuBYHep
                </p>{" "}
                <div className="copy-code">
                  {" "}
                  <MdContentCopy style={{ height: "15px", width: "15px" }} />
                </div>
              </div>

              <button className="profile-save-button">
                {" "}
                <MdContentCopy style={{ height: "15px", width: "15px" }} />
                Copy Key
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default Withdraw;
